import H2 from "@/atoms/text/H2";
import Para from "@/atoms/text/Para";
import Image from "@/atoms/Image";

const CommunitySupportSection = ({ title, content, image }) => {
  return (
    <section className="bg-img-section ps-r bc-white">
      <div className="container">
        <div className="ps-a pv-15-d pv-8 pr-8">
          {title && (
            <H2
              desktopSize="lg"
              mobileSize="sm"
              className="mb-5 w-50-d bold"
              color="white"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {content?.map((text, idx) => {
            const contentKey = `content_${idx}`;
            return (
              <Para
                key={contentKey}
                className={`w-50-d pr-7-d ${
                  idx === content.length - 1 ? "" : "mb-5"
                }`}
                desktopSize="lg"
                mobileSize="lg"
                color="white"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            );
          })}
        </div>
      </div>
      <Image
        fileName={image.fileName}
        desktopWidth={image.desktopWidth}
        mobileWidth={image.mobileWidth}
        alt={image.altName}
        fileFormat="jpg"
        imgStyle="w-100-d"
      />
      <style>{`
      @media (min-width: 1440px) {
        .bg-img-section {
          max-height: 600px;
          overflow: hidden;
        }
      }
      `}</style>
    </section>
  );
};

export default CommunitySupportSection;
